import { moduleApi } from '~/apis/module';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { IQueryGetModule, UpsertModuleWatchProgressBody } from '~/utils/interface/module';
import { GET_LIST_MODULE, UPSERT_MODULE_WATCH_PROGRESS } from '~/utils/constants/actionType';

export const upsertModuleWatchProgress = createAsyncThunk(
  UPSERT_MODULE_WATCH_PROGRESS,
  async ({ moduleId, body }: { moduleId: number; body: UpsertModuleWatchProgressBody }, { rejectWithValue }) => {
    try {
      const res = await moduleApi.upsertModuleWatchProgress(moduleId, body);
      return {
        moduleId,
        body,
        response: res.data,
      };
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getModules = createAsyncThunk(GET_LIST_MODULE, async (payload: IQueryGetModule, { rejectWithValue }) => {
  try {
    const res = await moduleApi.getModules(payload);
    return res.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});
